import { Grid, Typography } from "@material-ui/core";

export const LANDING_PAGES = [
  {
    url: "doucovani-vse",
    title: "Doučování předmětů z VŠE",
    description:
      "Jsem Fífa, legenda doučování předmětů z VŠE. Učil jsem přes 10 000 nešťastníků, kteří nechápali předměty jako Ekonomie, Účetnictví, Mikro, Manažerko a další.",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování VŠE? S Fífou na jistotu!
            </Typography>
            <Typography>
              Jsem Fífa a jestli něco umím, tak je to doučování předmětů z VŠE.
              Dřív jsem učil studenty pěkně face to face, ale pak mi došlo, že
              nemůžu bejt všude. Takže jsem v roce 2020 rozjel
              Videonalejvárny.cz – online doučování, kde si pustíš nalejvárnu
              kdykoliv, třeba i ve dvě ráno, když ti dojde, že zítra píšeš test
              a neumíš vůbec nic. 🫠
            </Typography>
            <Typography>
              Za ty roky mi prošlo rukama (a videama) přes 10 000 studentů VŠE,
              co se snažili přežít účetnictví, ekonomii a další předměty. A
              protože vím, jak to na týhle škole chodí, moje videa jsou přímo k
              věci – žádný omáčky, jen to, co fakt potřebuješ umět. Mimochodem,
              těch videí tady už je přes 1200.{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
  {
    url: "doucovani-ekonomie",
    title: "Doučování ekonomie (nejen) pro VŠE",
    description:
      "Jsem Fífa, legenda doučování účetnictví na VŠE. Eko naučím i tvoji babičku!",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování Ekonomie (nejen) pro VŠE
            </Typography>
            <Typography>
              Jsem Fífa a ekonomie je můj denní chleba (hned po pivu). Dřív jsem
              studenty doučoval osobně, ale pak mi došlo, že nemůžu bejt u
              každýho zoufalce zvlášť. Takže jsem v roce 2020 rozjel
              Videonalejvárny.cz – online doučování (nejen) ekonomie, kde si
              pustíš nalejvárnu kdykoliv, třeba i ve dvě ráno, když zjistíš, že
              máš test a zatím ovládáš akorát zákon nabídky a poptávky po bodu
              E. 🫠
            </Typography>
            <Typography>
              Pomohl jsem přes 10 000 studentům přežít mikro, makro a další
              ekonomický hrůzy. Všechno vysvětluju jasně a k věci – žádný
              zbytečný kecy, jen to, co fakt potřebuješ k testu. Na
              Videonalejvárnách už je přes 1200 videí, takže si najdeš přesně
              to, co ti zachrání kredity.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
  {
    url: "doucovani-mikroekonomie",
    title: "Doučování Mikroekonomine (nejen) pro VŠE",
    description:
      "Jsem Fífa, legenda doučování účetnictví na VŠE. Mikro naučím i totální jitrnici.",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování Mikroekonomine (nejen) pro VŠE
            </Typography>
            <Typography>
              Jsem Fífa a mikroekonomie už mi prošla rukama tolikrát, že bych za
              ni měl dostat čestnej doktorát. Dřív jsem doučoval lidi osobně,
              ale pak mi došlo, že nemůžu běhat za každým zoufalcem zvlášť. Tak
              jsem v roce 2020 rozjel Videonalejvárny.cz – online doučování, kde
              si pustíš nalejvárnu kdykoliv, třeba i ve dvě ráno, když zjistíš,
              že máš test a zatím ti není jasný ani to, proč se křivky kříží. 🫠
            </Typography>
            <Typography>
              Pomohl jsem víc než 10 000 studentům přežít mikro, makro a další
              ekonomický lahůdky. Žádný zbytečný kecy, jen to, co fakt
              potřebuješ k testu. Na Videonalejvárnách je přes 1200 videí, takže
              tam najdeš přesně to, co ti zachrání krk.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
  {
    url: "doucovani-statistika-vse",
    title: "Doučování statistiky (nejen) pro VŠE",
    description: "Legenda z VŠE ti ukáže, jak vy*ebat se statistikou!",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování statistiky (nejen) pro VŠE
            </Typography>
            <Typography>
              Jsem Fífa a statistikou jsem prošel tolikrát, že bych měl mít
              vlastní graf v učebnici. 📊 Dřív jsem doučoval lidi osobně, ale
              pak mi došlo, že nemůžu běhat za každým zoufalcem zvlášť. Tak jsem
              v roce 2020 rozjel Videonalejvárny.cz – online doučování, kde si
              pustíš nalejvárnu kdykoliv, třeba i ve dvě ráno, když zjistíš, že
              máš test a zatím ti není jasný ani to, co vlastně znamená
              směrodatná odchylka. 🫠 Statistiku neučím vyjímečně já, ale Marian.
            </Typography>
            <Typography>
              Doučoval jsem víc než 10 000 studentů, co si mysleli, že
              pravděpodobnost jejich úspěchu je čistě náhodná. 🤡 Žádný složitý
              vzorečky, co pochopí jen AI – jen to, co fakt potřebuješ k testu.
              Na Videonalejvárnách je přes 1200 videí na všecky předměty, takže
              si najdeš přesně to, co ti pomůže přežít.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
  {
    url: "doucovani-matematiky",
    title: "Doučování matematiky (nejen) pro VŠE",
    description:
      "Legenda doučování VŠE ti to spočítá. Ukážu ti, jak projít z matiky.",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování matematiky (nejen) pro VŠE
            </Typography>
            <Typography>
              Jsem Fífa, legenda doučování přesmětů z VŠE. Dřív jsem doučoval
              lidi osobně, ale pak mi došlo, že nemůžu běhat za každým zoufalcem
              zvlášť. Tak jsem v roce 2020 rozjel Videonalejvárny.cz – online
              doučování, kde si pustíš nalejvárnu kdykoliv, třeba i ve dvě ráno,
              když zjistíš, že ten test fakt nedáš jen na krásný oči. 🫠 Matiku
              neučím vyjímečně já, ale Vláďa.
            </Typography>
            <Typography>
              Doučoval jsem víc než 10 000 studentů, kteří tak nějak doufali, že
              to dají jak Sportku a natipují na stěstí. 🎲 Žádný složitý
              vzorečky, co chápe jen NASA – jen to, co fakt potřebuješ k testu.
              Na Videonalejvárnách je přes 1200 videí na všecky předměty, takže
              si najdeš přesně to, co ti pomůže přežít.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
  {
    url: "doucovani-ucetnictvi",
    title: "Doučování účetnictví s Fífou (nejen) pro VŠE",
    description:
      "Jsem Fífa, legenda doučování předmětů z VŠE. Učil jsem přes 10 000 nešťastníků, kteří nechápali předměty jako Ekonomie, Účetnictví, Mikro, Manažerko a další.",
    content: (
      <>
        <Grid container style={{ marginTop: 24 }} spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography variant={"h1"}>
              Doučování účetnictví s Fífou (nejen) pro VŠE
            </Typography>
            <Typography>
              Jsem Fífa a účto už jsem vysvětlil tolika studentům, že bych mohl
              dělat audit i finančáku. Dřív jsem doučoval osobně, ale pak mi
              došlo, že nemůžu zachraňovat každýho, kdo si myslí, že aktiva jsou
              něco do posilky a pasiva znamenaj, že se nemusí snažit. Tak jsem
              rozjel Videonalejvárny.cz – online doučování, kde si pustíš účto
              kdykoliv, třeba i ve dvě ráno, když ti dojde, že jedinej součet,
              co zvládáš, je na účtence z hospody. 📊🫠
            </Typography>
            <Typography>
              Pomohl jsem víc než 10 000 studentům VŠE pochopit účetnictví a
              neodnést si z něj jen trauma. Žádný složitosti, jen to, co fakt
              potřebuješ k testu. Na Videonalejvárnách už je přes 1200 videí,
              takže ať bojuješ s rozvahou, výsledovkou nebo nechápeš, proč se
              něco účtuje na stranu Dal, najdeš tam přesně to, co ti zachrání
              kredity. 🔥💰
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant={"h2"}>Vyber si předmět</Typography>
            <Typography>
              Ve videích máš všechno hezky po kapitolách, vypočítaný příklady a
              komplet nalejvárny na závěrečný testy i státnice. Žádný
              složitosti, prostě to, co musíš umět, abys prošel a nemusel
              prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
              vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
              testu nevypadat jak jelen před dálkovejma.
            </Typography>
          </Grid>
        </Grid>
      </>
    ),
  },
];
